"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_components_1 = require("@securityproducts/core-components");
var react_1 = __importDefault(require("react"));
// @ts-ignore
var react_tippy_1 = require("react-tippy");
var download_icon_1 = require("../../../svg/download.icon");
var print_icon_1 = require("../../../svg/print.icon");
var dateRange_service_1 = require("../../historical-report/date-picker/dateRange.service");
var dropdown_1 = require("../dropdown/dropdown");
var timezone_1 = require("../timezone/timezone");
var reportDescription_i18n_1 = require("./reportDescription.i18n");
var reportDescription_styles_1 = require("./reportDescription.styles");
exports.ReportDescription = function (props) {
    var hasFromDate = !!props.fromDate;
    var hasToDate = !!props.toDate;
    var hasPrint = !!props.print;
    var hasBothDates = hasFromDate && hasToDate;
    var strings = core_components_1.useLocalisation(reportDescription_i18n_1.reportDescripitonTranslations, props.language);
    function download() {
        props.download({
            fromDate: props.fromDate,
            toDate: props.toDate,
        });
    }
    var language = props.language ? props.language : core_components_1.getBrowserLanguage();
    var isRelative = rangeIsRelative(props.dateRange);
    return (react_1.default.createElement(core_components_1.ErrorBoundary, null,
        react_1.default.createElement("div", { id: "report-description", className: reportDescription_styles_1.reportDescriptionContainer },
            react_1.default.createElement("div", { id: "report-description-summary" },
                react_1.default.createElement("span", { id: "report-description-category" }, props.category),
                props.type && react_1.default.createElement("span", { id: "report-description-type" },
                    " - ",
                    props.type),
                isRelative && (react_1.default.createElement("span", { className: reportDescription_styles_1.rangeName, id: "report-description-range" },
                    "- ",
                    props.dateRange))),
            react_1.default.createElement("div", { id: "report-description-range", className: reportDescription_styles_1.range },
                hasBothDates && (react_1.default.createElement("div", { id: "report-description-date-range" },
                    react_1.default.createElement("span", { id: "report-description-from-date" }, core_components_1.customLocale(props.fromDate, language, {
                        month: "short",
                        day: "2-digit",
                        year: "numeric",
                        hour: "2-digit",
                        minute: "2-digit",
                    })),
                    " ",
                    "-",
                    " ",
                    react_1.default.createElement("span", { id: "report-description-to-date" }, core_components_1.customLocale(props.toDate, language, {
                        month: "short",
                        day: "2-digit",
                        year: "numeric",
                        hour: "2-digit",
                        minute: "2-digit",
                    })))),
                hasBothDates && props.timezone && react_1.default.createElement("div", { className: reportDescription_styles_1.divider }),
                props.timezone && (react_1.default.createElement("div", { id: "report-description-timezone", className: reportDescription_styles_1.timezoneContainer },
                    react_1.default.createElement(timezone_1.Timezone, __assign({}, props.timezone)))),
                react_1.default.createElement("div", { className: reportDescription_styles_1.buttons },
                    hasPrint && (react_1.default.createElement(react_tippy_1.Tooltip, { html: strings.comingSoon, open: props.showPrintTip, trigger: "mouseenter", arrow: true, theme: "dark" },
                        react_1.default.createElement(core_components_1.Button, { id: "print", onClick: props.print, className: reportDescription_styles_1.printButton, icon: true, text: true },
                            react_1.default.createElement(print_icon_1.PrintIcon, null),
                            strings.print))),
                    react_1.default.createElement(react_tippy_1.Tooltip, { html: strings.comingSoon, trigger: "mouseenter", open: props.showExportTip, arrow: true, theme: "dark" },
                        react_1.default.createElement(dropdown_1.Dropdown, { id: "export-dropdown", options: [
                                {
                                    text: strings.exportToCsv,
                                    action: download,
                                    id: "exportToCsv",
                                },
                            ], showOnLeft: true },
                            react_1.default.createElement("div", { className: reportDescription_styles_1.exportDropdown, id: "download" },
                                react_1.default.createElement(download_icon_1.DownloadIcon, null),
                                " ",
                                react_1.default.createElement("div", { className: reportDescription_styles_1.exportLabel }, strings.export)))))))));
};
function rangeIsRelative(range) {
    return (dateRange_service_1.DateRangeService.getInstance().relativeRangeLabels.findIndex(function (label) { return label === range; }) > -1);
}
